// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/next.scss
// module id = 1289
// module chunks = 132